export const getSmallSVGLogoURL = () => {
  return '/static/logoHybridSmall.svg';
};
